var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxUnchecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "#F3F5F6",
    stroke: "#D7D8DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50438 11.3921L8.50432 11.3922L8.51047 11.3983L10.2883 13.1762L10.6419 13.5298L10.9954 13.1762L15.5233 8.64833L15.5234 8.64838L15.5294 8.64213C15.6101 8.55856 15.7067 8.4919 15.8134 8.44604C15.9202 8.40018 16.035 8.37604 16.1512 8.37503C16.2674 8.37402 16.3826 8.39616 16.4901 8.44016C16.5977 8.48415 16.6954 8.54913 16.7775 8.63128C16.8597 8.71344 16.9246 8.81113 16.9686 8.91867C17.0126 9.0262 17.0348 9.14142 17.0338 9.2576C17.0328 9.37379 17.0086 9.4886 16.9628 9.59536C16.9169 9.70211 16.8502 9.79866 16.7667 9.87938L16.7666 9.87932L16.7605 9.88547L11.2605 15.3854C11.0964 15.5495 10.8739 15.6416 10.6419 15.6416C10.4099 15.6416 10.1874 15.5495 10.0233 15.3855C10.0233 15.3855 10.0233 15.3854 10.0233 15.3854L7.27332 12.6355L7.27338 12.6354L7.26713 12.6294C7.18355 12.5487 7.1169 12.4521 7.07104 12.3454C7.02518 12.2386 7.00104 12.1238 7.00003 12.0076C6.99902 11.8914 7.02116 11.7762 7.06516 11.6687C7.10915 11.5611 7.17413 11.4634 7.25628 11.3813C7.33844 11.2991 7.43613 11.2342 7.54367 11.1902C7.6512 11.1462 7.76642 11.124 7.8826 11.125C7.99878 11.126 8.1136 11.1502 8.22036 11.196C8.32711 11.2419 8.42366 11.3086 8.50438 11.3921Z",
    fill: "#D7D8DC",
    stroke: "#D7D8DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxUnchecked);
export default __webpack_public_path__ + "static/media/checkbox_unchecked.c838a379d92aea4463c88969868998b7.svg";
export { ForwardRef as ReactComponent };